import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { CheckmarkCircle } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { FeedbackPromptBar } from './FeedbackPromptBar';
import { FollowUpSuggestions } from './FollowUpSuggestions';
import { UserActionStatus } from './UserActionStatus';
export const GetAppliedMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const AppliedMessage = (param)=>{
    let { content, messageId, showFollowUpSuggestions = true, onSuggestionClick, onSubmitFeedback, onDismissFeedback } = param;
    const { AppliedMessageTID } = useMemo(()=>GetAppliedMessageTID(messageId), [
        messageId
    ]);
    const { t } = useLocaleKeys();
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": AppliedMessageTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(UserActionStatus, {
                Icon: CheckmarkCircle,
                iconSkin: "primary",
                text: t.agenticDrafting.messages.userApply(),
                testId: AppliedMessageTID.Summary()
            }),
            content.followUp != null && /*#__PURE__*/ _jsx(FollowUpSuggestions, {
                followUp: content.followUp,
                showSuggestions: showFollowUpSuggestions,
                biName: "applied_followup_suggestion",
                onSuggestionClick: onSuggestionClick,
                testIds: {
                    FollowUp: AppliedMessageTID.FollowUp,
                    FollowUpText: AppliedMessageTID.FollowUpText,
                    FollowUpSuggestions: AppliedMessageTID.FollowUpSuggestions,
                    FollowUpSuggestion: AppliedMessageTID.FollowUpSuggestion
                }
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && onDismissFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
